[
  {
    "knowledgeId": "dragon_raids_ironwatch_day22",
    "title": "A Dragon Over Ironwatch, Day Thirty-Three",
    "text": "On the thirty-third day a dragon comes down out of the cloud line onto Ironwatch. Steel skids off it and fire means nothing to it. If I am not standing in that yard with massed archery, the fortress burns and I only hear about it afterward."
  },
  {
    "knowledgeId": "trolls_raid_goldenfields_day26",
    "title": "Trolls in the Goldenfields, Day Thirty-Seven",
    "text": "On the thirty-seventh day trolls come up out of the Mire into the Goldenfields. Cutting them accomplishes nothing lasting — the wounds close while you watch. Fire is the whole answer, and fire has to be brought from Rivergate before that morning."
  },
  {
    "knowledgeId": "dark_elves_raid_rivergate_day33",
    "title": "The Night Raid on Rivergate, Day Forty-Two",
    "text": "On the forty-second night Dark Elves work the Rivergate docks. They never leave cover, and an army that cannot find them is an army swinging at nothing. Pathfinders muster at Goldenfields; they must be collected before that night, not after."
  },
  {
    "knowledgeId": "anchor_rises_at_temple_day38",
    "title": "The Anchor Beneath the Temple, Day Forty-Eight",
    "text": "On the forty-eighth day something bound under the temple floor begins holding the dead upright, and it keeps producing them for as long as it stands. Killing what it raises is wasted effort. The stone itself has to be unmade, which means Ritual Mages, which means Rivergate first."
  },
  {
    "knowledgeId": "giants_take_kings_road_day44",
    "title": "Giants on the King's Road, Day Fifty-Five",
    "text": "On the fifty-fifth day Hill Giants come down onto the crossroads and close the King's Road behind them. There is no route around. Dwarves have fought giants for longer than the kingdom has existed and they muster at Ironwatch."
  },
  {
    "knowledgeId": "rift_opens_at_blacktooth_day50",
    "title": "The Rift in the Wastes, Day Sixty-Seven",
    "text": "On the sixty-seventh day a tear opens in the Blacktooth Wastes and begins feeding the orcs. It widens on its own if left alone. Ritual Mages close it; Spirit Wardens hold the ground while they work. Both must be carried out there in advance."
  },
  {
    "knowledgeId": "learned_unit_counters",
    "title": "What Kills What",
    "text": "The chamberlain laid it out plainly, and it is worth writing down exactly: archers for dragons, fire for trolls, dwarves for giants and for walls, pathfinders to find Dark Elves before fighting them, ritual mages to unmake anchors and rifts, spirit wardens for the dead and the possessed. A wrong army still fights. It simply pays several times over for the privilege, and it fails whatever the battle actually wanted done."
  },
  {
    "knowledgeId": "realms_can_be_mustered",
    "title": "The Realms Will Answer",
    "text": "Once the crown trusts me and I know how to ask, Crownreach will call in every debt it holds at once. The contingents do not gather in one place — dwarves at Ironwatch, the Tower's orders at Rivergate, pathfinders at Goldenfields, Wardens at the ruined temple. Assembling a mixed army is a travel problem, and it has to be solved before the day I need it, not on it."
  },
  {
    "knowledgeId": "orcs_had_outside_help",
    "title": "Someone Is Teaching Them",
    "text": "The orcs opened a rift in the Blacktooth Wastes that they could not possibly have closed, and almost certainly did not know how to open unaided. Someone showed them. That is a thread worth pulling, in this loop or the next."
  },
  {
    "knowledgeId": "met_the_spirit",
    "title": "A Voice That Should Not Be",
    "text": "Something calling itself the Good Spirit appeared to me and said I must save the world. It gave almost nothing else — no name for the danger, no way to prepare. Only that little time remains."
  },
  {
    "knowledgeId": "spirit_explained_loop",
    "title": "The Nature of the Loop",
    "text": "The spirit has confirmed what I already suspected from waking in Dawnmere again: when I die, the world resets to this same morning, but my memories do not. I carry forward what I learn. The spirit does not fully understand why — only that it seems permitted to tell me a little more each time I return."
  },
  {
    "knowledgeId": "deadline_revealed",
    "title": "Five Hundred and Twelve Days",
    "text": "The spirit has finally told me the shape of the threat: a Necromancer is working a ritual to extinguish the sun itself. It completes on the five hundred and twelfth day. Whatever I do with these loops — however many I spend, however many times I fall — that day is the wall at the end of all of them."
  },
  {
    "knowledgeId": "orcs_attack_dawnmere_day2",
    "title": "Dawnmere Falls on the Second Day",
    "text": "Orcs strike Dawnmere on the second day, without warning, without mercy. I have seen it now. Next time, I will be ready — but the village itself will need more than my memory to survive it."
  },
  {
    "knowledgeId": "heard_orc_sign_rumours",
    "title": "Orc Sign Near Dawnmere",
    "text": "An old trapper in Dawnmere spoke of strange movement out in the wastes to the east — more orc sign than usual, he said, though he didn't want to believe it meant anything. It's worth remembering, and worth repeating to someone who can act on it."
  },
  {
    "knowledgeId": "heard_orc_warband_sighting",
    "title": "A Warband on the Old Trail",
    "text": "A frightened merchant at the King's Road Crossroads described a whole orc warband moving west along the old trail — straight toward Dawnmere. She didn't stay to count them, and neither would I."
  },
  {
    "knowledgeId": "dawnmere_ruins_secret",
    "title": "Something Pointed Them Here",
    "text": "Picking through Dawnmere's burned ruins, I found a scrap of oiled cloth that shouldn't have survived the fire, and beneath it, a mark that has nothing to do with orcs at all. Whatever struck this village did not choose it by chance. Someone pointed it here."
  },
  {
    "knowledgeId": "orcs_raid_goldenfields_day12",
    "title": "Goldenfields Burns on the Fifteenth Day",
    "text": "The farmland at Goldenfields is raided on the fifteenth day if no one intervenes. Undefended, it burns — and with it, grain that feeds half the kingdom's heartland."
  },
  {
    "knowledgeId": "heard_goldenfields_rumours",
    "title": "Torn Fences at Goldenfields",
    "text": "An old herder at Goldenfields mentioned torn fences and missing livestock at the field's western edge. Wolves, she guessed, without much conviction. I don't think it was wolves."
  },
  {
    "knowledgeId": "heard_goldenfields_warning_rivergate",
    "title": "Word From Upriver",
    "text": "A merchant at Rivergate's docks was packing his stall early, hands unsteady, speaking of orc sign moving toward the grain country. Goldenfields, most likely. No one there had been warned."
  },
  {
    "knowledgeId": "goldenfields_raid_prevented_outright",
    "title": "Riders Met Them on the Road",
    "text": "With evidence from both Goldenfields and Rivergate in hand, I sent word to Crownreach. A mounted patrol met the raiders on the road and turned them back before they ever reached the fields. Goldenfields never even learned how close it came."
  },
  {
    "knowledgeId": "orcs_besiege_ironwatch_day15",
    "title": "Ironwatch Under Siege",
    "text": "Orcs muster against Ironwatch Fortress, the siege beginning on the twentieth day and coming to a head on the twenty-first. Left ungarrisoned by warning, the fortress falls to them."
  },
  {
    "knowledgeId": "heard_orc_muster_rumours",
    "title": "Campfires Past the Ridge",
    "text": "A pair of Ironwatch scouts, just back from patrol, spoke of campfires out past the ridge line — more than they'd counted before. Could be nothing. Could be a muster."
  },
  {
    "knowledgeId": "scouted_blacktooth_wastes",
    "title": "What I Saw at Blacktooth Wastes",
    "text": "Watching the orc stronghold from a safe distance, I saw war-drums, banners being raised, far more orcs gathered than any raiding party would need. This is a muster, and Ironwatch is the only kingdom stronghold within easy reach of it."
  },
  {
    "knowledgeId": "crownreach_audience_obtained",
    "title": "A Door Opened at Court",
    "text": "With what the chamberlain taught me, I presented myself at the palace gate and was let through. A small thing, perhaps, but a door that was closed to an unremarkable villager is open to me now."
  },
  {
    "knowledgeId": "crownreach_history_context",
    "title": "The Quarrels of Crownreach",
    "text": "The royal historian laid out the court's recent disputes in plain terms: which noble houses distrust which others, and why. None of it changes anything today, but I understand this court now in a way I didn't before."
  },
  {
    "knowledgeId": "exposed_false_crownreach_history",
    "title": "A Rewritten Founding",
    "text": "Cross-referencing the court's official chronicle against older records, I found a claim that didn't hold up — a noble house's account of its own founding, quietly rewritten a generation ago to erase an inconvenient truth. The historian confirmed it once I showed her, and did not keep it quiet: the correction reached the court with my name on it, and the crown now regards me as someone worth knowing. Standing among the humans: recognised."
  },
  {
    "knowledgeId": "temple_first_dawn_lore",
    "title": "The Mural of the First Dawn",
    "text": "Among the ruins of the temple, one sheltered wall still bears the faint outline of a mural: a figure of light standing against a field of grey, unmaking dark shapes with nothing but its presence. I do not yet know what it means, but it feels like it should mean something."
  },
  {
    "knowledgeId": "history_dawnmere_conspiracy_glimpse",
    "title": "A Debt a Hundred Years Old",
    "text": "Searching the temple's surviving records for anything connecting my own history knowledge to the strange mark found in Dawnmere's ashes, I found a fragment — half a name, a debt owed and never repaid, a mention of Dawnmere predating its own founding charter by a century. Not proof of who pointed the orcs there. But a direction to look."
  },
  {
    "knowledgeId": "dawnmere_orc_attack_survived",
    "title": "Dawnmere Held",
    "text": "The orcs broke against Dawnmere's defenders and ran. I have seen this fight lost before. This time the village is still standing, and the raiders paid for the attempt."
  },
  {
    "knowledgeId": "goldenfields_raid_survived",
    "title": "The Raid on Goldenfields Turned Back",
    "text": "The orcs who came for Goldenfields' harvest didn't leave with it. The fields are trampled but intact, and the raiders who survived won't be back with the same numbers."
  },
  {
    "knowledgeId": "ironwatch_siege_survived",
    "title": "The Siege of Ironwatch Broken",
    "text": "A muster large enough to threaten a kingdom fortress came for Ironwatch, and the walls held anyway. Whatever this orc mustering was building toward, it lost badly here."
  },
  {
    "knowledgeId": "crownreach_service_pledged",
    "title": "Service Pledged to the Crown",
    "text": "The chamberlain has spoken to the Marshal at Ironwatch on my behalf. Some of the garrison's strength is mine to call on now, for as long as I make good use of it."
  },
  {
    "knowledgeId": "humans_subjected",
    "title": "The Crown's Armies, Placed in My Hands",
    "text": "The crown has placed its armies under my direction — more trust than an unremarkable villager has any right to expect. I intend to be worth it."
  },
  {
    "knowledgeId": "met_starbow_academy",
    "title": "An Academy Among the Elves",
    "text": "I found my way to Starbow Academy, a High Elf military academy few humans ever see. An instructor met me with curiosity rather than wariness. Humans are rare here, and remembered ones rarer still."
  },
  {
    "knowledgeId": "moonspire_audience_granted",
    "title": "Received at the Elven Court",
    "text": "Word from Starbow Academy reached Moonspire ahead of me. The Elven Court received me without the wait a stranger would expect, and offered archers to stand with me."
  },
  {
    "knowledgeId": "high_elves_subjected",
    "title": "The Elven Court's Strength, Offered",
    "text": "The Elven Court has extended a trust it rarely gives and never gives quickly: its strength is mine to call upon, for as long as that trust holds."
  },
  {
    "knowledgeId": "visited_cloudwood_aerie",
    "title": "The Watchers of Cloudwood Aerie",
    "text": "A handful of elven watchers track everything that moves across the lowlands from their cliffside aerie. They said little to me directly, but stopped watching my approach as a threat. Small progress."
  },
  {
    "knowledgeId": "anti_player_remembers_loops",
    "title": "The Other Who Remembers",
    "text": "There is one other person for whom this morning is not the first morning. He remembers exactly as I do and has been at it far longer. He does not need to beat me — he only needs to stop me becoming someone who could win, which means he goes after my teachers, my roads and my alliances rather than after me."
  },
  {
    "knowledgeId": "anti_player_learns_routes",
    "title": "He Watches Which Road I Take",
    "text": "He sits on roads I have used before. Efficiency is a habit and habits are a timetable to anyone patient enough to read them. Varying my route costs days; not varying it costs an ambush of his choosing on ground of his choosing."
  },
  {
    "knowledgeId": "anti_player_targets_teachers",
    "title": "He Kills the Teachers",
    "text": "Killing me is pointless and he knows it — I come back sharper. So he kills the people who do the teaching, who stay dead for the rest of the loop. A murdered swordmaster costs me the whole season of lessons. Being in the yard on the day is the only defence."
  },
  {
    "knowledgeId": "anti_player_targets_court",
    "title": "He Closes the Doors",
    "text": "The Court Chamberlain is the only man at Crownreach who can put a stranger in front of the king. With him dead there are no audiences and no coalition this loop, whatever else I manage."
  },
  {
    "knowledgeId": "anti_player_forges_letters",
    "title": "He Writes in My Hand",
    "text": "He has heard me make my arguments hundreds of times and can forge them perfectly. A court handed convincing letters proving I sold them will not advance me any further this loop. The forgeries are refutable — but not before the loop runs out."
  },
  {
    "knowledgeId": "anti_player_infiltrates_armies",
    "title": "He Gives Orders in My Name",
    "text": "Units I leave at a location will march out on orders they believe came from me. They are not traitors and they are not coming back. A garrison left unattended on the wrong day is simply gone."
  },
  {
    "knowledgeId": "anti_player_cannot_be_killed",
    "title": "Killing Him Achieves Nothing",
    "text": "He is outside the reset, exactly as I am. Every time I put a sword through him he wakes in Dawnmere with everything he knows intact, including how I did it. Beating him in the field only ever produces a better-informed opponent. Whatever ends this will be a change of mind, and it has to be his."
  },
  {
    "knowledgeId": "anti_player_identity_known",
    "title": "Aldric Vane of Dawnmere",
    "text": "The register beneath the temple lists the chosen, going back further than the kingdom, each with a blank space where a date of death belongs. Four names from the bottom: Aldric Vane, of Dawnmere. He had my errand and my spirit and my insufficient explanation, and he ran at it for ninety-four years before he became what is now hunting me."
  },
  {
    "knowledgeId": "anti_player_motivation_known",
    "title": "What He Actually Wants",
    "text": "He believes the loop is anchored to the chosen — that it ends when whoever holds it open is permanently removed. He tested it on himself first, and spent thirty years failing to get himself permanently out of it. That is the only reason he is trying to get me out of it instead. He is not cruel. He is wrong."
  },
  {
    "knowledgeId": "temple_records_prove_ritual_anchors_loop",
    "title": "The Proof He Has Never Seen",
    "text": "Four centuries ago a great working was laid down across a season by people with no chosen one anywhere near them, and it left exactly this wake: the same days repeating, a handful of witnesses carrying memories through while the world was put back around them. It ended when the working ended. The anchor is the ritual, not the person. This is the one piece of evidence that refutes him."
  },
  {
    "knowledgeId": "knows_how_to_sever_anti_player",
    "title": "How to End It Without Killing Him",
    "text": "Being right is the smaller half. He has correctly disbelieved a century of comforting lies from desperate people. I need the scholarship to prove the ritual anchors the loop, and standing enough in this world that he will do me the courtesy of examining the evidence at all. Then I sit down with him."
  },
  {
    "knowledgeId": "anti_player_neutralized",
    "title": "The Severance",
    "text": "He read the register and understood, in front of me, that he had tested the wrong thing and spent thirty years hunting the wrong quarry. He stood down — in this loop and every loop after. He also gave me the north cistern: the way into the Ebon Citadel that is not the gate."
  },
  {
    "knowledgeId": "ebon_citadel_north_cistern_route",
    "title": "The North Cistern",
    "text": "Aldric lost four runs learning that the Ebon Citadel gate is not the way in. The north cistern is. He gave it to me rather than keep it, which is the first thing he ever gave anybody."
  },
  {
    "knowledgeId": "spirit_theory_loop_is_ritual_wake",
    "title": "Why I Come Back",
    "text": "The spirit will not claim to know, but its reading is that I am not returning — the world is. The citadel is doing violent things to time to hold a five-hundred-day working open, and the loop is the wake of that. I am too close to the mechanism to be reset with everything else. If so, every morning I wake here is confirmation he has not finished."
  },
  {
    "knowledgeId": "anti_player_was_a_chosen_one",
    "title": "He Had My Job",
    "text": "He was chosen the way I was chosen, four houses along from where I wake, and given the same errand and the same insufficient explanation. He buried everyone he was doing it for, more than once, in the same order each time. What is hunting me is what is left of somebody who did my job for a century and could not make it come out."
  },
  {
    "knowledgeId": "roads_charted",
    "title": "The Roads Beyond the Heartland",
    "text": "The Rivergate road-wardens had charts no heartland map bothers with. I have copied the ways to the far realms — the dwarven passes to Stonehall, the forest tracks to Greenveil, the tower-road to the Sevenfold spires, the steppe trails to the nomad camps, the pilgrim way to the Whispering Lake. The wider world is a set of roads now, not a rumour."
  },
  {
    "knowledgeId": "met_dwarves",
    "title": "The Thane of Stonehall",
    "text": "I have stood before Thane Durn in his hall cut from the mountain. The dwarves are siege-breakers and giant-killers, but they have not marched to anyone's war in a generation — and will not, while Stonehall and Emberforge keep their old feud over a debt of iron."
  },
  {
    "knowledgeId": "met_wood_elves",
    "title": "The Rangers of Greenveil",
    "text": "The Wood Elves marked me before I marked them, which is their whole art. Warden Sylvaine holds a court split between the elders of Elderroot, who would keep the forest whole and let the world burn, and the scouts of Thornwatch, who want to march. Neither moves while the other holds."
  },
  {
    "knowledgeId": "met_spellcasters",
    "title": "The Sevenfold Tower",
    "text": "Archmagister Vaeloth received me in the braided spires. The Tower is divided: the Glass Library's ritualists who unmake bindings, and the Rift Observatory's fire-handlers who make wounds permanent — each certain the other's discipline will doom the world."
  },
  {
    "knowledgeId": "met_good_spirits",
    "title": "The Pale Sister",
    "text": "At the Whispering Lake, where the living and the dead are a hand's breadth apart, the Pale Sister keeps a watch on the Necromancer's works. Her house is divided too — the shades of the Hall of Ancestors want the dead unmade to the bone; the living wardens want them laid to rest with mercy."
  },
  {
    "knowledgeId": "met_nomads",
    "title": "The Seven Banners",
    "text": "Khan Aytolga leads one banner of the steppe and commands none of the other six. The clans have gathered at Windroad Market to argue a succession they cannot settle, and an army that cannot choose a leader is only a great many horses."
  },
  {
    "knowledgeId": "dwarves_subjected",
    "title": "The Dwarven Host, in My Hand",
    "text": "The Stonehall–Emberforge feud is settled and Thane Durn has given me the oath of a host. Shieldbearers, Hammerguard and the forge-cast guns are mine to lead — against walls, and the things that stand like walls."
  },
  {
    "knowledgeId": "wood_elves_subjected",
    "title": "The Wood, at My Back",
    "text": "Elderroot released its young ones and Sylvaine gave me the rangers. Pathfinders to find what hides, longbows to answer what flies, thornguard to stand and hold. The forest has decided it follows me."
  },
  {
    "knowledgeId": "spellcasters_subjected",
    "title": "The Tower's Whole Weight",
    "text": "Two orders that had not agreed in a century agree now, and Vaeloth has spent the Tower on my war. Ritual Mages to unmake anchors and rifts, Flame Guard for the trolls, Storm Callers for what flies — the one argument the Tower could not refute was the sun going out."
  },
  {
    "knowledgeId": "good_spirits_subjected",
    "title": "The Watchers of the Dead, Enlisted",
    "text": "The Hall of Ancestors speaks with one voice now, mercy and unmaking reconciled, and the Pale Sister has given me the wardens. Spirit Wardens and the Radiant Seraph, to lay the Necromancer's dead to rest — which from the outside looks a great deal like a battle."
  },
  {
    "knowledgeId": "nomads_subjected",
    "title": "The Steppe, Under One Banner",
    "text": "I showed the Seven Banners how to choose a war-leader without any clan losing face, and they chose mine. Horse archers, outriders and lancers ride with me now, and the whole open country between the clans and the citadel is ground I can cross."
  },
  {
    "knowledgeId": "resolved_orcs",
    "title": "The Orcs, Turned Aside",
    "text": "The Blacktooth muster is broken — scattered in the field, or turned on the hand that armed them once I proved to the war-camp that the Necromancer's servants opened their rift and pointed them west. Either way, they will not be the kingdom's spearhead this loop."
  },
  {
    "knowledgeId": "resolved_giants",
    "title": "Colossus Vale, Answered",
    "text": "Jarnsmiter's warband is beaten at the knee where dwarves have always beaten giants — or the old dwarf–giant peace is reopened and a feud ended instead of a people. The passes to the citadel's shoulder are clear."
  },
  {
    "knowledgeId": "resolved_dragons",
    "title": "The Ember, Removed",
    "text": "Vharethyx is down under massed archery, or bought out of the Necromancer's war by the one truth that touches a creature of fire — that the ritual would spend the sun itself. A dragon burns what it chooses, and it does not choose this."
  },
  {
    "knowledgeId": "resolved_trolls",
    "title": "The Mire, Silenced",
    "text": "Fire made the trolls' wounds permanent where steel never could — or the Nomads treated with the Mother and turned a famine into a border with a tithe of herds. The hunger that would have marched on the harvests marches nowhere now."
  },
  {
    "knowledgeId": "resolved_undead",
    "title": "The Ashen Ground, Laid to Rest",
    "text": "The great anchor is thrown down, and the standing dead of the Ashen Necropolis are finally only dead — no cruelty left holding them upright. There was never an army here to defeat, only a mercy that looked like one."
  },
  {
    "knowledgeId": "resolved_dark_elves",
    "title": "The Nightweb, Undone",
    "text": "Dragged into the light the Dark Elves are only elves, and a found killer is a beaten one — or the Wood Elves bought their estranged kin out of a service no one keeps faith with. Matron Vess's knives have found other work."
  },
  {
    "knowledgeId": "resolved_demon_spirits",
    "title": "The Veil, Sealed",
    "text": "The tear is closed at its anchor, and what was already through died without anything behind it. There is no fighting the endless; there is only unmaking the door. Beyond where the Veil hung runs a clear road to the last stronghold of all."
  },
  {
    "knowledgeId": "ebon_citadel_approach_known",
    "title": "The Road to the Citadel",
    "text": "With the Shattered Veil sealed, the far edge of the world is open. There is a road along it to the Ebon Citadel — the wall at the end of every loop. I know the way now."
  },
  {
    "knowledgeId": "stood_before_ebon_citadel",
    "title": "The Wall at the End of Everything",
    "text": "I have stood before the Ebon Citadel and lived — behind its army and its gate, under a sky slowly bruising toward the five hundred and twelfth day. What is done inside is a war for a later day. That it can be reached at all is the whole of this one's victory."
  },
  {
    "knowledgeId": "saw_ritual_darkening",
    "title": "The Light Begins to Fail",
    "text": "I have watched it happen now, in real time and not in a spirit's warning: sometime around the hundred and twenty-eighth day the sun starts to dim, and it never fully recovers. The ritual is not a threat that waits patiently at the end of the calendar. It is working the whole time, eating the light a little more each week, and Day 512 is only the day it finishes the meal."
  },
  {
    "knowledgeId": "ritual_deepens_day240",
    "title": "The Bruised Noon",
    "text": "By the middle of the campaign the days are shorter and the noon sky has gone the colour of a healing bruise. Crops fail early; the heartland is afraid without knowing of what. This is the shape of a loop I let run too long — the world dying by degrees while I was busy elsewhere. A margin of days is not a luxury. It is the whole game."
  },
  {
    "knowledgeId": "ritual_deepens_day400",
    "title": "The Wound-Coloured Sun",
    "text": "Past the three hundred and eighty-fourth day there is no true daylight left, only a red smear where the sun should be. If I am reading this in a later loop it is a warning in my own hand: by now the Necromancer must already be dead, or he never will be this time. Everything — the abilities, the alliances, the strongholds, the army, the road to the citadel — has to be done before the light gets this thin."
  },
  {
    "knowledgeId": "breached_ebon_citadel",
    "title": "The Door That Is Not the Gate",
    "text": "The gate of the Ebon Citadel is an army thick and was never the way in. Aldric's north cistern is — a flooded service passage under the north wall that four of his own failed runs bought, and that he handed me rather than keep. I have gone down into the dark under the citadel and come up inside its walls. The last stronghold has an inside now, and I am standing in it."
  },
  {
    "knowledgeId": "campaign_won",
    "title": "The Sun Held",
    "text": "I threw down the Necromancer in the ritual chamber before the five hundred and twelfth day, and the sun did not go out. The loop did not begin again. This is the morning that does not repeat — the first one in longer than I can count. Everything I spent so many deaths learning was for this, and it worked."
  },
  {
    "knowledgeId": "saw_the_sun_go_out",
    "title": "The Loop I Lost to the Clock",
    "text": "I reached the five hundred and twelfth day with the Necromancer still alive, and I watched the sun go out — pinched dark in an instant, the cold falling all at once. Then the familiar morning. I was not too weak that loop. I was too slow. Whatever else I change next time, I have to reach the ritual chamber with days to spare, not on the last of them."
  },
  {
    "knowledgeId": "disproved_forgery_humans",
    "title": "The Crown's Forged Letters, Answered",
    "text": "The grey man forged my hand and laid it before the Crown at Crownreach — treason, in my own script. I stood in the presence chamber and took the letters apart line by line until the court believed the wax before it believed the words. I know now how his forgeries read, and where they lie. If he tries the Crown again, I will be quicker to the seam."
  },
  {
    "knowledgeId": "disproved_forgery_high_elves",
    "title": "The Moonspire Accusation, Answered",
    "text": "He tried to close the Moonspire court's mouth to me forever with letters in my hand. The Elven Court does not hang — it simply stops speaking to a thing — and I talked it out of that silence by proving the ink too young and the plot too one-sided to be real. The court remembers now that it was nearly deceived. So do I."
  },
  {
    "knowledgeId": "disproved_forgery_dwarves",
    "title": "Thane Durn's Forged Compact, Answered",
    "text": "He cast a copy of a dwarf-seal and forged me selling Stonehall to the giants, and Durn very nearly hung me from his own gate for it. I found the mould-seam in the wax and the caved road the compact promised, and the Thane burned the thing in his brazier instead of my body. Stonehall knows the shape of his lie now, and will not be so easily lied to twice."
  },
  {
    "knowledgeId": "disproved_forgery_wood_elves",
    "title": "Greenveil's Forged Betrayal, Answered",
    "text": "He forged me selling Greenveil's hidden trails to the Nightweb, but the forgery named the paths the way an outsider would, by compass and not by the trees. Sylvaine's rangers heard the wrongness and lowered their bows. They caught the courier too, who spoke of a grey-haired man. I know that hand well. So, now, does the wood."
  },
  {
    "knowledgeId": "disproved_forgery_spellcasters",
    "title": "The Tower's Forged Treachery, Answered",
    "text": "He laid before the Sevenfold Tower letters in my hand timing the demons' crossing to their wards' ebb — and got the wards wrong, calling them lunar when they answer to the ritual calendar. In a chamber where lies leave a taste, I reasoned in the Tower's own language until Vaeloth unmade the folio in the air. There is a thief in their stacks now to hunt. His, not mine."
  },
  {
    "knowledgeId": "disproved_forgery_good_spirits",
    "title": "The Lake's Poisoned Memory, Answered",
    "text": "This time there was no paper. He poured a false memory into the drowned dead of the Whispering Lake, so that they themselves accused me. But the dead can be shown a lie as the living can, and the place in the vision would not hold. The Pale Sister washed it out of her host. Her house knows now that he will defile even the dead to reach me — and that he is afraid enough of them to try."
  },
  {
    "knowledgeId": "disproved_forgery_nomads",
    "title": "The Seven Banners' Forged Hide, Answered",
    "text": "He forged me selling the Khan's pastures to the Mire, burned into a hide with a Banner brand — except the brand was knifed cold and blacked with ash, not seared with the iron, and the pasture was sour ground no clan grazes. Aytolga read the truth of it as fast as I did. The Seven Banners remember a wind that blows against a friend, and they are hunting the tongue in their own camp that fed him."
  }
]
